module.exports = __webpack_public_path__ + "static/screen-2-c119c0f390e6f071eef3edca0a5e9fbe.png";